import React, { useCallback } from "react";
import { MB_Button } from "@workingu/rnw.components.button";
import { MB_ModalMobileBottom } from "@workingu/rnw.components.modal";
import { StyleSheet, Text } from "react-native";
import { mbTextStyles } from "@workingu/rnw.utils.style-utils";
import { COLORS } from "../../constants/colors";
import { textStyles } from "../../constants/textStyles";
import { useSignedInContext } from "../../context/SignedInContext";
import Ionicons from "react-native-vector-icons/Ionicons";


const LogoutModal = ({ isVisible, onDismiss }: { isVisible: boolean, onDismiss?: () => void }) => {

    const { signOut } = useSignedInContext();

    const onLogOut = useCallback(() => {
        onDismiss?.();
        setTimeout(signOut, 500);
    }, [onDismiss, signOut]);

    return (
        <MB_ModalMobileBottom
            isVisible={isVisible}
            onDismiss={onDismiss}
            childrenWrapperStyle={styles.container}
        >
            <Text style={styles.title}>Log out of this account?</Text>
            <Text style={styles.description}>You are about to log out of your account.</Text>
            <MB_Button
                title="Yes, log out"
                style={styles.logoutBtn}
                textStyle={styles.logoutBtnText}
                leftElement={<Ionicons name="exit-outline" color={COLORS.white} size={15} />}
                onPress={onLogOut}
            />
            <MB_Button
                title="Cancel"
                style={styles.cancelBtn}
                textStyle={styles.cancelBtnText}
                onPress={onDismiss}
            />
        </MB_ModalMobileBottom>
    )
};

export { LogoutModal };

const styles = StyleSheet.create({
    container: {
        backgroundColor: COLORS.white,
        paddingHorizontal: 20,
        alignItems: 'stretch',
        paddingBottom: 32,
        paddingTop: 20,
    },
    title: mbTextStyles([textStyles.largeText, {
        fontSize: 21,
        color: COLORS.headerText,
        textAlign: 'left',
        fontWeight: '800',
    }]),
    description: mbTextStyles([textStyles.smallerText, {
        color: COLORS.bodyText,
        textAlign: 'left',
        marginTop: 3,
    }]),
    logoutBtn: {
        backgroundColor: COLORS.red,
        borderRadius: 30,
        height: 50,
        marginTop: 25,
    },
    logoutBtnText: {
        color: COLORS.white
    },
    cancelBtn: {
        backgroundColor: 'transparent',
        borderRadius: 30,
        height: 50,
        borderWidth: 1,
        borderColor: COLORS.primaryColor,
        marginTop: 10,
    },
    cancelBtnText: {
        color: COLORS.primaryColor,
    }
})